import React, { useState } from "react";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/SidebarMainAccount.js";
import Header from "components/Navbars/MainAccountNavbar";
import routesMainAccounts from "routes-main-account";
import { AppointmentRoutes } from "views-main-account/AppointmentList";
import { useSelector } from "react-redux";
import { userSelector } from "slices/userSlice";

function MainAccountDashboard(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const mainPanel = React.useRef();
  const location = useLocation();
  const { user } = useSelector(userSelector);

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const filteredRoutes = routesMainAccounts.filter(route => {
    if (user?.role === 'client_sub_user' && route.path === '/sub-users') {
      return false;
    }
    return true;
  });

  return (
    <div className="wrapper">
      <Sidebar
        {...props}
        routes={filteredRoutes}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <div className={`main-panel ${isSidebarOpen ? "collaped" : ""}`} ref={mainPanel}>
        <Header {...props} toggleSidebar={toggleSidebar} />
        <Routes>
          {filteredRoutes.map((prop, key) => {
            return (
              <Route
                path={prop.path}
                element={prop.component}
                key={key}
              />
            );
          })}

          <Route path="/appointments/*" element={<AppointmentRoutes />} />
        </Routes>
        <Footer fluid />
      </div>
      <Outlet />
    </div>
  );
}

export default MainAccountDashboard;
